// 黑料站 · 首页内容数据（静态展示用）

export interface NavItem {
  label: string;
  key: string;
}

export const siteNav: NavItem[] = [
  { label: "首页", key: "top" },
  { label: "频道入口", key: "entry" },
  { label: "话题墙", key: "tags" },
  { label: "热度榜", key: "rank" },
  { label: "专题精选", key: "feature" },
  { label: "短讯速览", key: "feed" },
  { label: "栏目目录", key: "directory" },
];

export const heroStats = [
  { num: "238K", label: "全站内容条目" },
  { num: "38", label: "主频道" },
  { num: "12.6K", label: "今日更新" },
];

export const heroQuick = ["全网追更", "按题材追更", "按地区追更", "按热度追更"];

export interface EntryItem {
  name: string;
  en: string;
  icon: string;
  desc: string;
  count: string;
  subs: string[];
}

export const entryItems: EntryItem[] = [
  {
    name: "频道",
    en: "CHANNEL",
    icon: "ri-radio-2-line",
    desc: "按题材聚合的主频道，站内内容总入口，追更不迷路。",
    count: "38",
    subs: ["商业", "娱乐", "消费"],
  },
  {
    name: "分区",
    en: "SECTION",
    icon: "ri-layout-grid-line",
    desc: "频道之下更细的落点分区，按话题走向精准分流。",
    count: "172",
    subs: ["品牌", "平台", "人物"],
  },
  {
    name: "专题",
    en: "FEATURE",
    icon: "ri-stack-line",
    desc: "围绕单一事件的多视角合辑，把来龙去脉一次看全。",
    count: "64",
    subs: ["深度", "追踪", "盘点"],
  },
  {
    name: "板块",
    en: "BOARD",
    icon: "ri-layout-masonry-line",
    desc: "常驻内容板块，固定更新的栏目入口与讨论主场。",
    count: "29",
    subs: ["速览", "求证", "开讲"],
  },
  {
    name: "栏目",
    en: "COLUMN",
    icon: "ri-file-list-3-line",
    desc: "固定栏目连载更新，按节奏持续产出与归纳。",
    count: "116",
    subs: ["日报", "周察", "图鉴"],
  },
  {
    name: "目录",
    en: "INDEX",
    icon: "ri-list-unordered",
    desc: "全站归档目录，按标签与时间轴快速回找内容。",
    count: "9.4K",
    subs: ["标签", "归档", "检索"],
  },
];

export interface TagItem {
  name: string;
  count: number;
}

export const hotTags: TagItem[] = [
  { name: "价格争议", count: 3182 },
  { name: "虚假宣传", count: 2954 },
  { name: "门店乱象", count: 2710 },
  { name: "售后拉锯", count: 2468 },
  { name: "数据合规", count: 2205 },
  { name: "霸王条款", count: 1977 },
  { name: "质量翻车", count: 1843 },
  { name: "平台抽成", count: 1651 },
  { name: "加盟纠纷", count: 1402 },
  { name: "预售逾期", count: 1236 },
  { name: "营销套路", count: 1088 },
  { name: "用工争议", count: 954 },
  { name: "翻车实录", count: 876 },
  { name: "维权难", count: 731 },
  { name: "倒闭跑路", count: 652 },
  { name: "资质存疑", count: 540 },
];

export interface RankItem {
  title: string;
  cat: string;
  views: string;
  heat: number;
}

export const heatRank: RankItem[] = [
  { title: "平台新规上调服务费，商户集中发声引发连锁关注", cat: "商业", views: "328万", heat: 98 },
  { title: "头部连锁品牌门店被曝后厨卫生乱象，多地上热搜", cat: "消费", views: "291万", heat: 94 },
  { title: "网红代购宣传夸大功效，实测结果与口播严重不符", cat: "消费", views: "256万", heat: 90 },
  { title: "直播带货售后形同虚设，退货纠纷数据连月走高", cat: "娱乐", views: "223万", heat: 85 },
  { title: "头部平台算法推荐争议再起，内容审核尺度被质疑", cat: "舆论", views: "198万", heat: 81 },
  { title: "某连锁健身房多地闭店，预付费会员维权陷入拉锯", cat: "消费", views: "172万", heat: 76 },
  { title: "数据公司违规收集用户信息，监管开出巨额罚单", cat: "商业", views: "149万", heat: 71 },
  { title: "爆款单品排队抢购背后，被指营销饥饿制造焦虑", cat: "消费", views: "126万", heat: 66 },
  { title: "明星代言品牌遭曝光，舆情扩散速度刷新近期纪录", cat: "娱乐", views: "104万", heat: 61 },
  { title: "售后客服外包被曝外包话术模板，体验两极分化", cat: "职场", views: "88万", heat: 56 },
];

export interface FeaturedBoard {
  cover: string;
  tag: string;
  title: string;
  excerpt: string;
  reads: string;
  parts: number;
}

export const featuredBoards: FeaturedBoard[] = [
  {
    cover: "https://readdy.ai/api/search-image?query=dark%20editorial%20photo%20of%20city%20skyline%20at%20night%20with%20warm%20amber%20lights%20and%20newspaper%20documents%20on%20desk%20in%20foreground%2C%20no%20people%2C%20moody%20investigative%20journalism%20mood%2C%20high%20contrast%2C%20cinematic%20depth&width=1200&height=900&seq=hls-board-01&orientation=landscape",
    tag: "深度专题",
    title: "平台抽成重压之下：中小商户的生存实录",
    excerpt: "三地走访二十余家中小商户，还原抽成上调背后的连锁反应与各方说法。",
    reads: "186万",
    parts: 6,
  },
  {
    cover: "https://readdy.ai/api/search-image?query=dark%20editorial%20photo%20of%20a%20stack%20of%20confidential%20documents%20with%20red%20stamps%20and%20sealed%20envelopes%20under%20desk%20lamp%20light%2C%20no%20people%2C%20mysterious%20exposure%20theme%2C%20deep%20shadows%2C%20warm%20single%20light%20source%2C%20cinematic&width=1200&height=900&seq=hls-board-02&orientation=landscape",
    tag: "求证档案",
    title: "一盒口罩的前世今生：层层代工与品质迷局",
    excerpt: "从生产资质到检测报告逐层查证，还原一条代工链条里的灰色地带。",
    reads: "152万",
    parts: 8,
  },
  {
    cover: "https://readdy.ai/api/search-image?query=dark%20editorial%20photo%20of%20empty%20boardroom%20meeting%20table%20with%20documents%20folder%20and%20laptop%2C%20no%20people%2C%20cool%20tungsten%20lighting%20against%20dark%20glass%2C%20corporate%20investigation%20mood%2C%20cinematic%20depth%20of%20field&width=1200&height=900&seq=hls-board-03&orientation=landscape",
    tag: "商业追踪",
    title: "从辉煌到闭店：一家连锁品牌的失控一百天",
    excerpt: "时间轴复盘扩张、资金链与加盟体系为何在三个月内接连崩盘。",
    reads: "137万",
    parts: 5,
  },
  {
    cover: "https://readdy.ai/api/search-image?query=dark%20editorial%20photo%20of%20smartphone%20with%20magnifying%20glass%20examining%20a%20product%20label%20on%20wooden%20table%2C%20no%20people%2C%20macro%20detail%2C%20warm%20desk%20light%2C%20consumer%20rights%20verification%20theme%2C%20shallow%20depth%20of%20field%2C%20cinematic&width=1200&height=900&seq=hls-board-04&orientation=landscape",
    tag: "消费鉴定",
    title: "直播间的“全网最低价”，到底低在了哪里",
    excerpt: "逐条比价、拆解话术与定金规则，看看低价承诺背后的文字游戏。",
    reads: "121万",
    parts: 7,
  },
  {
    cover: "https://readdy.ai/api/search-image?query=dark%20editorial%20photo%20of%20a%20gavel%20and%20scale%20of%20justice%20on%20desk%20with%20legal%20case%20folders%2C%20no%20people%2C%20low%20key%20lighting%2C%20amber%20and%20shadow%2C%20regulatory%20enforcement%20theme%2C%20cinematic%2C%20serious%20tone&width=1200&height=900&seq=hls-board-05&orientation=landscape",
    tag: "监管观察",
    title: "重罚之后：违规数据公司为何还敢“换皮”营业",
    excerpt: "处罚落地与否的监管盲区，以及灰产公司如何迅速转移阵地。",
    reads: "109万",
    parts: 4,
  },
  {
    cover: "https://readdy.ai/api/search-image?query=dark%20editorial%20photo%20of%20microphone%20and%20press%20notebook%20in%20dim%20event%20venue%20with%20bokeh%20lights%2C%20no%20people%2C%20moody%20media%20event%20atmosphere%2C%20journalism%20theme%2C%20warm%20accents%2C%20cinematic%20depth&width=1200&height=900&seq=hls-board-06&orientation=landscape",
    tag: "舆论漩涡",
    title: "一场热搜背后的操纵术：我们如何被带节奏",
    excerpt: "拆解热搜词条从发酵、反转到定调的完整传播链路。",
    reads: "98万",
    parts: 9,
  },
];

export interface NewsItem {
  tag: string;
  title: string;
  time: string;
  reads: string;
  hot: number;
}

export const newsFeed: NewsItem[] = [
  { tag: "商业", title: "连锁咖啡品牌被曝加盟商运营成本虚高，总部回应称正在核实", time: "5分钟前", reads: "3.2万", hot: 92 },
  { tag: "消费", title: "网红即食燕麦实测脂肪标注与检测出入，涉事方下架致歉", time: "11分钟前", reads: "2.8万", hot: 87 },
  { tag: "娱乐", title: "综艺录影被曝剧本痕迹明显，节目组深夜发布长文澄清", time: "18分钟前", reads: "4.1万", hot: 90 },
  { tag: "职场", title: "大厂年终绩效细则流出，内部晋升通道与加班口径引热议", time: "26分钟前", reads: "1.9万", hot: 74 },
  { tag: "科技", title: "知名智能手表被曝虚标续航，实验室实测缩水近四成", time: "34分钟前", reads: "2.2万", hot: 78 },
  { tag: "消费", title: "某生鲜平台被指以“规格差”换货，用户晒单维权持续发酵", time: "42分钟前", reads: "1.6万", hot: 69 },
  { tag: "娱乐", title: "演唱会被曝大量回流票加价，票务平台回应将排查异常账号", time: "51分钟前", reads: "3.6万", hot: 83 },
  { tag: "职场", title: "多地出现“先入职后辞退”套路，劳动仲裁咨询量明显上升", time: "1小时前", reads: "1.4万", hot: 63 },
  { tag: "科技", title: "短视频平台收藏夹被曝自动清理，官方称系缓存策略误伤", time: "1小时前", reads: "2.0万", hot: 71 },
  { tag: "消费", title: "线下门店“最低消费”仍存，多家被点名后悄悄撤下告示", time: "2小时前", reads: "1.2万", hot: 58 },
  { tag: "商业", title: "宠物品牌被曝代工厂混用原料批次，质检报告遭质疑", time: "2小时前", reads: "1.8万", hot: 66 },
  { tag: "娱乐", title: "剧组被曝拖欠群演薪资，制片方回应称结算流程延误所致", time: "3小时前", reads: "2.6万", hot: 79 },
];

export interface ColumnGroup {
  group: string;
  items: string[];
}

export const directoryGroups: ColumnGroup[] = [
  {
    group: "题材追更",
    items: ["商业竞争", "消费维权", "科技产品", "娱乐舆论", "职场职场", "生活服务"],
  },
  {
    group: "观点观察",
    items: ["深度复盘", "数据追踪", "监管解读", "行业冷观察", "舆情画像"],
  },
  {
    group: "常驻栏目",
    items: ["每日速览", "每周榜单", "事件时间轴", "求证档案", "翻车图鉴", "热词释义"],
  },
  {
    group: "时间归档",
    items: ["今日更新", "本周汇总", "本月热度", "年度盘点"],
  },
];

export const footerCols: Array<{ title: string; links: string[] }> = [
  { title: "站点导航", links: ["频道入口", "热度榜单", "专题精选", "栏目目录"] },
  { title: "内容体系", links: ["内容准则", "线索征集", "事实核查", "更新日志"] },
  { title: "合作往来", links: ["商务合作", "内容授权", "意见反馈", "联系我们"] },
];